'use client'

import { createClient } from '@/lib/supabase/client'
import { useEffect, useState } from 'react'
import { X } from 'lucide-react'
import Link from 'next/link'

export function TopBanner() {
    const [ads, setAds] = useState<any[]>([])
    const [visible, setVisible] = useState(true)
    const [currentAdIndex, setCurrentAdIndex] = useState(0)
    const supabase = createClient()

    useEffect(() => {
        const fetchAds = async () => {
            const today = new Date().toISOString()
            const { data } = await supabase
                .from('ads')
                .select('*')
                .eq('is_active', true)
                .or(`end_date.gt.${today}`) // Only show current ads
                .order('created_at', { ascending: false })

            if (data && data.length > 0) {
                // Filter specifically for top_banner if location logic is strict, otherwise just take all for 'top' fallback
                const topAds = data.filter(ad => ad.location === 'top_banner' || !ad.location)
                setAds(topAds)
            }
        }
        fetchAds()
    }, [])

    // Rotate ads every 5 seconds if multiple
    useEffect(() => {
        if (ads.length <= 1) return

        const interval = setInterval(() => {
            setCurrentAdIndex((prev) => (prev + 1) % ads.length)
        }, 5000)

        return () => clearInterval(interval)
    }, [ads])

    if (!visible || ads.length === 0) return null

    const currentAd = ads[currentAdIndex]

    return (
        <div className="relative bg-black border-b border-white/10 w-full overflow-hidden">
            {/* Close Button */}
            <button
                onClick={() => setVisible(false)}
                className="absolute right-2 top-1/2 -translate-y-1/2 z-20 text-white/50 hover:text-white p-1"
                aria-label="Fermer la publicité"
            >
                <X size={16} />
            </button>

            {/* Ad Content */}
            <div className="container mx-auto max-w-7xl px-4 py-2 flex items-center justify-center h-20 md:h-28">
                {currentAd.link_url ? (
                    <a href={currentAd.link_url} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center h-full w-full">
                        <img
                            src={currentAd.image_url}
                            alt={currentAd.title}
                            className="h-full w-auto object-contain transition-all hover:scale-[1.01]"
                        />
                    </a>
                ) : (
                    <div className="flex flex-col items-center justify-center h-full w-full">
                        <img
                            src={currentAd.image_url}
                            alt={currentAd.title}
                            className="h-full w-auto object-contain"
                        />
                    </div>
                )}
            </div>

            {/* Dots for multiple ads */}
            {ads.length > 1 && (
                <div className="absolute bottom-1 left-1/2 -translate-x-1/2 flex gap-1">
                    {ads.map((_, idx) => (
                        <div
                            key={idx}
                            className={`w-1.5 h-1.5 rounded-full transition-colors ${idx === currentAdIndex ? 'bg-primary' : 'bg-white/20'}`}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}
